import * as React from 'react';

type FacebookProps = {
  width?: number;
  height?: number;
};

// tslint:disable:max-line-length
export const Facebook = (props: FacebookProps) => (
  <svg width={props.width || 16} height={props.height || 17} viewBox='0 0 16 17' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16 15.599995c0 .4877-.395304.883005-.883005.883005h-4.077252v-6.19629h2.079812l.311624-2.414535h-2.391437V6.33062c0-.69908.194383-1.175887 1.196807-1.175887l1.278745-.000436v-2.15957c-.221405-.029637-.980196-.095448-1.863202-.095448-1.84359 0-3.105772 1.12533-3.105772 3.192066v1.78083H6.46128v2.414534h2.08504V16.483H.883006C.395305 16.483 0 16.087696 0 15.599995V1.366005C0 .878305.395304.483.883005.483h14.23399c.4877 0 .883005.395304.883005.883005v14.23399'
      fill='#FFF'
      fillRule='evenodd'
    />
  </svg>
);



// WEBPACK FOOTER //
// src/app/src/components/Icons/Facebook.tsx